import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, type Ref } from 'vue';
import { useRoute } from 'vue-router';
import { ChevronRightIcon, QuestionMarkCircleIcon } from '@heroicons/vue/outline';

import { useFilterStore, useAuraStore } from '@/stores';
import { can } from '@/composables/useAuth';

import { type NavigationItem, type LevelModel } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateNavigation',
  props: {
    items: {
        type: Array as () => NavigationItem[],
        default: () => [],
    },
},
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();
const filterStore = useFilterStore();
const auraStore = useAuraStore();

const props = __props;

const filteredNavigationItems: Ref<NavigationItem[]> = ref([]);

const levelFilter = computed<LevelModel | null>(() => filterStore.level);

const isActive = (item: NavigationItem) => {
    if (item.name === 'Home') {
        return route.name === item.name;
    } else {
        return route.matched.some(({ name }) => {
            if (typeof name !== 'string') return false;
            return name === item.name || item.activateBy?.includes(name);
        });
    }
};

const hasActiveChildren = (item: NavigationItem) =>
    (item.children || []).some((i: NavigationItem) => isActive(i));

const toggleVisibility = (item: NavigationItem) => {
    item.isOpen = !item.isOpen;
};

let navigationRefreshSequence = 0;

const updateNavigationItems = () => {
    filteredNavigationItems.value = props.items
        .map((item) => {
            return !item.children?.length
                ? item
                : {
                      ...item,
                      children: item.children.filter(
                          (child) => !child.permission || can(child.permission),
                      ),
                  };
        })
        .filter((item, index) => {
            if (item.localeKey === 'sideNavigation.meet.group' && !levelFilter.value?.meeting) {
                return false;
            }
            if (item.localeKey === 'sideNavigation.aura' && auraStore.isAuraEnabled !== true) {
                return false;
            }
            return props.items[index].children?.length === undefined
                ? !item.permission || can(item.permission)
                : item.children?.length;
        });
};

const refreshNavigation = async () => {
    const refreshSequence = ++navigationRefreshSequence;
    const contextRequest = auraStore.checkContext();
    updateNavigationItems();
    await contextRequest;
    if (refreshSequence !== navigationRefreshSequence) return;
    updateNavigationItems();
};

watch(() => levelFilter.value?.id, refreshNavigation, { immediate: true });

const __returned__ = { route, filterStore, auraStore, props, filteredNavigationItems, levelFilter, isActive, hasActiveChildren, toggleVisibility, get navigationRefreshSequence() { return navigationRefreshSequence }, set navigationRefreshSequence(v) { navigationRefreshSequence = v }, updateNavigationItems, refreshNavigation, get ChevronRightIcon() { return ChevronRightIcon }, get QuestionMarkCircleIcon() { return QuestionMarkCircleIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})